import { Component, OnInit } from '@angular/core';
import { PropertyService } from '../../services/property/property.service';
import { Router } from '@angular/router';
import { PriceFormatterService } from '../../services/price-formatter/price-formatter.service';
import { faHeart, faSearch } from '@fortawesome/free-solid-svg-icons';
import { StorageKeys } from '../share/enums/storage.enum';
import { StorageService } from '../../services/storage/storage.service';
@Component({
  selector: 'app-featured-properties',
  templateUrl: './featured-properties.component.html',
  styleUrl: './featured-properties.component.scss'
})
export class FeaturedPropertiesComponent implements OnInit {
  // Add a loading flag for favorite toggling
loadingFavorites: { [propertyId: string]: boolean } = {};

    public readonly faSearch = faSearch;
    public readonly faHeart = faHeart;
      verifyLoader: boolean = false;
        isLoginModalVisible: boolean = false;
        isEnquiry: boolean = false;
          isAdmin: boolean = false;
         selectedPropertyId: any;
          status: any;
isLoading: boolean = false;

  constructor (  private propertyService: PropertyService,
    private router        : Router,
    private priceFormatterService: PriceFormatterService,
        private storageService: StorageService,
  ){}

  ngOnInit(): void {
    this.getFeaturedProperties()
  }

  featuredProperties : any ;


  getFeaturedProperties() {
    this.propertyService.featuredProperties()?.subscribe({
      next: (res: any) => {
        this.featuredProperties = res?.data.map((property: any) => {
          return {
            ...property,
            formattedPrice: this.priceFormatterService.formatPrice(property.minimumPrice)
          };
        });
      },
      error: (error: any) => {
        console.error('Error fetching featured properties', error);
      }
    });
  }

  openProjectView(property: any) {
    this.router.navigate(['/property-details'], {queryParams: {pid: property._id}})
  }

  getTotalAsset(price:any,size:any){
    return this.priceFormatterService.formatPrice(price * size);
  }


  get checkLoginStatus() {
    if (localStorage.getItem('token')) {
      return true;
    } else {
      return false;
    }
  }

    getLocalStorageDetails() {
      this.status = this.storageService.getDataFromLocalStorage(
        StorageKeys.enrollmentType
      );
      if (this.status === 'Admin') {
        this.isAdmin = true;
      }
    }
    closeProjectModal() {
    this.isLoginModalVisible = false;
    this.getLocalStorageDetails();
  }

    openEnquiry(value: any) {
    if (this.checkLoginStatus) {
      this.selectedPropertyId = value?._id;
      this.isEnquiry = true;
    } else {
      this.isLoginModalVisible = true;
    }
  }

  toggleFavorite(event: Event, value: any): void {
  event.stopPropagation();

  if (this.checkLoginStatus) {
    // Optimistic toggle before API response
    value.favProperty = !value.favProperty;

    this.propertyService.selectFavorite(value._id).subscribe({
      next: (res: any) => {
        // Optionally refresh full list if needed
        this.getFeaturedProperties();
        this.verifyLoader = false;
      },
      error: (error: any) => {
        // Revert back if API failed
        value.favProperty = !value.favProperty;
        console.error(error);
      }
    });
  } else {
    this.openEnquiry(value);
  }
}

}
